import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { mobileScreen } from "../utils/breakpoints";

const NavItem = styled(NavLink)`
  color: #c74747;
  text-decoration: none;
  outline: 0;
  display: flex;
  flex-direction: row;

  &:hover {
    color: #c74747;
  }
`;

const ExternalNavLink = styled.a`
  color: #c74747;
  text-decoration: none;
  outline: 0;
  display: flex;
  flex-direction: row;

  &:hover {
    color: #c74747;
  }
`;

const Container = styled.div`
  height: 100%;
`;

const WelcomeMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-top: 4%;
  width: 100%;
`;

const WelcomeMessage = styled.h1`
  font-size: 38px;
  display: flex;
  justify-content: center;
  color: #444546;

  ${mobileScreen} {
    font-size: 32px;
    width: 100%;
  }
`;

const ExternalLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`;

export {
  NavItem,
  ExternalNavLink,
  Container,
  WelcomeMessageContainer,
  WelcomeMessage,
  ExternalLinkContainer,
};
